module.exports = __webpack_public_path__ + "static/media/Q8.ea628d48.svg";